import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import CSS from 'csstype';
import React from 'react';

import { publicaColors } from '~/src/dash/utils/colors';

const ARROW_STYLE = { fontSize: '13px', paddingBottom: '1px' };
const POSITIVE_COLOR = publicaColors.darkGreen;
const POSITIVE_COLOR_BACKGROUND = publicaColors.veryLightGreen;
const NEGATIVE_COLOR = publicaColors.lightRed;
const NEGATIVE_COLOR_BACKGROUND = publicaColors.veryLightRed;
const NEUTRAL_COLOR = publicaColors.gray;
const NEUTRAL_COLOR_BACKGROUND = publicaColors.veryLightGray;

export const getTrendColor = (value: number, isInverseTrend?: boolean) => {
  switch (true) {
    case value > 0:
      return isInverseTrend ? NEGATIVE_COLOR : POSITIVE_COLOR;
    case value < 0:
      return isInverseTrend ? POSITIVE_COLOR : NEGATIVE_COLOR;
    case value === 0:
    default:
      return NEUTRAL_COLOR;
  }
};

export const getTrendColors = (value: number, isInverseTrend?: boolean) => {
  switch (true) {
    case value > 0:
      return {
        text: isInverseTrend ? NEGATIVE_COLOR : POSITIVE_COLOR,
        background: isInverseTrend ? NEGATIVE_COLOR_BACKGROUND : POSITIVE_COLOR_BACKGROUND,
      };
    case value < 0:
      return {
        text: isInverseTrend ? POSITIVE_COLOR : NEGATIVE_COLOR,
        background: isInverseTrend ? POSITIVE_COLOR_BACKGROUND : NEGATIVE_COLOR_BACKGROUND,
      };
    case value === 0:
    default:
      return {
        text: NEUTRAL_COLOR,
        background: NEUTRAL_COLOR_BACKGROUND,
      };
  }
};

export const displayArrow = (value: number, color: string, style?: CSS.Properties) => {
  switch (true) {
    case value > 0:
      return <ArrowUpwardIcon style={{ ...ARROW_STYLE, color, ...(style || {}) }} />;
    case value < 0:
      return <ArrowDownwardIcon style={{ ...ARROW_STYLE, color, ...(style || {}) }} />;
    default:
      return null;
  }
};

export const calculateTrend = (mainValue: number, compareValue: number) => {
  if (!compareValue) return 0;
  return ((mainValue - compareValue) / compareValue) * 100;
};
